import * as React from "react";
import { forwardRef } from "react";
const SvgArrowDecrease = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M18 15L16.59 13.59L13 17.17V3H11V17.17L7.41 13.58L6 15L12 21L18 15Z", fill: "#C4D9FF" }));
const ForwardRef = forwardRef(SvgArrowDecrease);
export { ForwardRef as ReactComponent };
